/**
 * G6. Ночь: укачать — 4 такта плача за 10 секунд; промах — здоровье −2
 * (недосып), ребёнку ничего не грозит. Написано до начала.
 */
import { t } from '@life/i18n';
import { NIGHT_MISS_HEALTH, type NightInput, type NightState } from '@life/minigames';
import type { MinigameScreenProps } from './types';
import { Tap } from './ui/Tap';

export function Night({ state, onInput }: MinigameScreenProps<NightInput, NightState>) {
  return (
    <>
      <p class="hint">{t('ui.minigame.night.rules', { beats: state.beats.length, s: state.durationMs / 1000, w: state.window, h: NIGHT_MISS_HEALTH })}</p>
      <Tap beats={state.beats} durationMs={state.durationMs} tapLabel={t('ui.minigame.night.rock')} onDone={(taps) => onInput({ taps })} />
    </>
  );
}
